import React from 'react';
import { makeStyles, createStyles, Theme } from "@material-ui/core"
import TransitionFade from '../../transition/TransitionFade';

const useStyle = makeStyles((theme: Theme) => createStyles({
    paper: {
        padding: 10
    }
}
));

const ContentArea: React.FC = ({ children }) => {
    const classes = useStyle();
    return (

        <TransitionFade>
            <div className={`${classes.paper}`}>
                {children}
            </div>
        </TransitionFade>
    );
}

export default ContentArea;